"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _row = _interopRequireDefault(require("../../../../core/row"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _rowConfig = _interopRequireDefault(require("../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../core/label"));
var _selectCode = _interopRequireDefault(require("../../../../core/select-code"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _ref = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Please check the rules to see whether paddler is eligible to enter another class as a non-ranked competitor.");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Existing Class");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Existing Division");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Bib/Paddler");
var _ref5 = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "warning"
}, /*#__PURE__*/_react.default.createElement("p", null, "Please be aware that you may need to supply proof of your Paddle UK membership to the organiser."));
class NonRankedFromExisting extends _react.Component {
  render() {
    const existing = this.props.existing;
    return /*#__PURE__*/_react.default.createElement("div", null, _ref, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 3
      }, {
        sm: 9
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      "data-test-id": "select-existing-class",
      lookup: "RefCodes",
      codeType: "class",
      value: existing.existingClassRef,
      onChange: this.props.setValue.bind(this, 'existingClassRef'),
      clearable: false
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      "data-test-id": "select-existing-class-division",
      lookup: "ClassDivisions",
      classRef: existing.existingClassRef,
      value: existing.existingClassDivisionID,
      onChange: this.props.setValue.bind(this, 'existingClassDivisionID'),
      clearable: false
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      "data-test-id": "select-existing-paddler-id",
      lookup: "PaddlersByBib",
      classDivisionID: existing.existingClassDivisionID,
      yearID: +this.props.yearID,
      value: existing.existingPaddlerID,
      onChange: this.props.setValue.bind(this, 'existingPaddlerID'),
      clearable: false
    }))))), _ref5);
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = NonRankedFromExisting;